// extracted by mini-css-extract-plugin
export default {"wrapper":"Box_wrapper__LpYYX","inner":"Box_inner__FsGXV","dark":"Box_dark__DNFpy","loading":"Box_loading__aIPwi"};